import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input, InputProps } from '../../UI';
import { InvestmentFormValues } from '../types';
import { FC } from 'react';

type InvestmentNicknameInputProps = Pick<InputProps, 'className'> & InputProps['inputProps'];

export const InvestmentNicknameInput: FC<InvestmentNicknameInputProps> = ({ className, ...inputProps }) => {
  const { t: tForm } = useTranslation('form');
  const {
    register,
    formState: { errors },
  } = useFormContext<InvestmentFormValues>();

  return (
    <Input
      className={className}
      {...register('nickname', { required: true })}
      status={errors.nickname ? 'errored' : 'normal'}
      label={tForm('investment-nickname-input-label')}
      inputProps={{ placeholder: tForm('general-required-placeholder'), ...inputProps }}
    />
  );
};
